export default __webpack_public_path__ + "static/media/movieassist.d13ce75b.gif";